<template>
    <div id="app-main">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name : "app",
}
</script>
<style lang="less">
 #app-main {
    width: 100%;
    height: 100%;
    background: #fff;
 }
</style>

